import { useState } from 'react';
import { basDeploymentPageKeys, guidedSectionMapping } from '../../const';
import { CongratsTemplate } from '../../CommonTemplates';
import PrimaryBasCommunications from './PrimaryBASCommunications';
import AvailableBasCommunications from './AvailableBasCommunications';
import { updateSectionStatusThunk } from '../../../../../redux/inputSheet/inputSheetSlice';
import { useSelector, useDispatch } from 'react-redux';

const DeploymentConfigurationOnboarding = ({ onClose, setShowSnackbar }) => {
	const [pageNumber, setPageNumber] = useState(0);

	const deploymentConfigurationPages = {
		[basDeploymentPageKeys.PRIMARY_BAS_COMMUNICATIONS]: (
			<PrimaryBasCommunications
				setShowSnackbar={setShowSnackbar}
				setPageNumber={setPageNumber}
			/>
		),
		[basDeploymentPageKeys.AVAILABLE_BAS_COMMUNICATIONS]: (
			<AvailableBasCommunications
				setShowSnackbar={setShowSnackbar}
				setPageNumber={setPageNumber}
			/>
		),
		[basDeploymentPageKeys.SUCCESS]: (
			<DeploymentConfigurationSuccess onClose={onClose} />
		),
	};

	return <>{deploymentConfigurationPages[pageNumber]}</>;
};

function DeploymentConfigurationSuccess({ onClose }) {
	const dispatch = useDispatch();
	const propertyId = useSelector((state) => state.selectedBuilding.prop_id);

	const handleClose = () => {
		dispatch(
			updateSectionStatusThunk({
				propertyId,
				data: {
					[guidedSectionMapping['Deployment Configuration'].key]: {
						isComplete: true,
						isStarted: true,
						section_id:
							guidedSectionMapping['Deployment Configuration'].section_id,
					},
				},
			})
		);
		onClose();
	};
	return (
		<CongratsTemplate
			title="Thank you!"
			message="Your information has been saved successfully."
			onClick={handleClose}
		/>
	);
}

export default DeploymentConfigurationOnboarding;
